export {default as QuickActionsView} from './src/views/QuickActionsView';